import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
})
export class InstructionsComponent {
  constructor() {}

  @Input() print: boolean;
}



// WEBPACK FOOTER //
// ./src/app/instructions/instructions.component.ts